import superagent from '@ott/superagent';
import _groupBy from 'lodash/groupBy';
import * as T from './actionTypes';

const allowedGeoTypes = [
  'city',
  'republic',
  'island',
  'peninsula',
  'district',
  'region',
  'municipality',
  'state',
  'province',
  'tourist_area',
  'area',
  'bay',
  'sight',
];

const localitiesGroup = 'localities';
const sightsGroup = 'sights';

function prepareOption(item) {
  return item.type === 'sight'
    ? {
        id: item.id,
        sightId: item.sight_id,
        name: item.sight_name,
        type: item.type,
        description: `${item.name}, ${item.country}`,
        key: `${item.id}-${item.sight_id}`,
      }
    : {
        id: item.id,
        name: item.name,
        type: item.type,
        description: item.country,
        key: item.id,
      };
}

function prepareLocations(locations = []) {
  const filteredItems = locations.filter(({ type }) => allowedGeoTypes.includes(type));

  const groupedItems = _groupBy(filteredItems, item => {
    if (item.type === 'sight') {
      return sightsGroup;
    }

    return localitiesGroup;
  });

  return [localitiesGroup, sightsGroup].reduce((acc, groupName) => {
    const hasItemsInGroup = groupedItems[groupName]?.length;

    if (hasItemsInGroup) {
      if (groupName === sightsGroup && acc.length) {
        acc.push({
          isGroup: true,
          groupSlug: 'Достопримечательности',
        });
      }

      acc.push(...groupedItems[groupName].map(prepareOption));
    }

    return acc;
  }, []);
}

export function fetchLocations(term) {
  return async dispatch => {
    dispatch({ type: T.FETCH_LOCATIONS_START });
    const response = await superagent
      .get('/_activities/v2/suggest')
      .query({
        name: term,
        limit: 10,
      })
      .timeout(20000)
      .catch(error => {
        dispatch({
          type: T.FETCH_LOCATIONS_FAIL,
          error,
        });
      });

    if (response) {
      dispatch({
        type: T.FETCH_LOCATIONS_SUCCESS,
        payload: prepareLocations(response.body),
      });
    }
  };
}

export function selectLocation(payload) {
  return {
    type: T.SELECT_LOCATION,
    payload,
  };
}

export function setQueue(payload) {
  return {
    type: T.SET_QUEUE,
    payload,
  };
}
